'use strict';

var tslib_es6 = require('./tslib.es6-13d783d6.js');
var styled = require('styled-components');

var scroll = function (axis, hideScrollBar) {
    if (hideScrollBar === void 0) { hideScrollBar = false; }
    return styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    overflow-x: ", ";\n    overflow-y: ", ";\n    -webkit-overflow-scrolling: touch;\n\n    ", "\n"], ["\n    overflow-x: ", ";\n    overflow-y: ", ";\n    -webkit-overflow-scrolling: touch;\n\n    ",
        "\n"])), axis === 'x' ? 'scroll' : 'hidden', axis === 'y' ? 'scroll' : 'hidden', hideScrollBar &&
        "\n        scrollbar-width: none; // hide scroll bar on firefox\n        -ms-overflow-style: none; // hide scroll bar on IE 10+\n        &::-webkit-scrollbar {\n            display: none; // hide scroll bar on Chrome and Safari\n        }\n    ");
};
var templateObject_1;

exports.scroll = scroll;
//# sourceMappingURL=scroll-20137af2.js.map
